module.exports = __webpack_public_path__ + "img/google-play-store.1685778f.svg";